import React from 'react';
import { Button } from 'afl-design-system';

export const Buttons = () => {
    const variants = ['primary', 'secondary', 'outline', 'ghost', 'glass'];
    const sizes = ['large', 'medium', 'small'];

    return (
        <div className="flex flex-column">
            <h3 className="text-title-m">Buttons</h3>
            <div className="mt-m flex gap-s items-center flex-wrap">
                {variants
                    .map((variant) =>
                        sizes
                            .map((size) => (
                                <Button
                                    key={`button-${variant}-${size}`}
                                    variant={variant}
                                    size={size}
                                >{`${variant} ${size}`}</Button>
                            ))
                            .flat()
                    )
                    .flat()}
            </div>
        </div>
    );
};
